module.exports = __webpack_public_path__ + "static/media/Celebi_gaussian2.20506936.png";